import { PaldeskModuleFederation } from '@paldesk/module-federation/core';
import { environment } from './environments/environment';

PaldeskModuleFederation.replaceEnvironmentFile(
  environment.production
    ? 'assets/config/config.json'
    : 'assets/config/config.development.json',
  environment,
)
  .then(() =>
    PaldeskModuleFederation.prepareHost({
      hostName: 'claim-on-suppliers',
      env: environment.env,
      remotes: environment.remotes,
    }),
  )
  .then(() => import('./bootstrap'));
